import { ReactElement } from 'react';
import UserRole from '../../../model/currentuser/UserRole';
import CurrentUserDetail from '../../../model/currentuser/CurrentUserDetail';

interface Props {
  pouzivatel: CurrentUserDetail;
  children: ReactElement;
  allowForRoles?: Array<UserRole>;
  additionalCheck?: boolean;
  elseChildren?: ReactElement;
}

export const isAuthorized = (allowForRoles: Array<UserRole>, user: CurrentUserDetail): boolean => {
  const userRoles = user == null ? [] : user.opravnenia;
  if (!allowForRoles) {
    return true;
  }
  if (!userRoles || userRoles.length === 0 || allowForRoles.length === 0) {
    return false;
  }
  return userRoles.some(role => allowForRoles.includes(role));
};

const SecuredComponent = ({
  children, allowForRoles, pouzivatel, additionalCheck = true, elseChildren = null,
}: Props): ReactElement => {
  if (isAuthorized(allowForRoles, pouzivatel) && additionalCheck) {
    return children;
  }

  return elseChildren;
};

export default SecuredComponent;
